import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from './arrow.svg'


const _hoisted_1 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass(['title'])
}
const _hoisted_2 = {
  key: 0,
  class: "header-1"
}
const _hoisted_3 = {
  key: 2,
  class: "header-2"
}
const _hoisted_4 = { class: "gallery-row" }
const _hoisted_5 = { class: "page-arrow-before" }
const _hoisted_6 = ["alt"]
const _hoisted_7 = { style: {"position":"relative"} }
const _hoisted_8 = { class: "page-arrow-after" }
const _hoisted_9 = ["alt"]

import axios, { AxiosError, CanceledError } from "axios";
import {
    type PropType,
    computed,
    onBeforeMount,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
} from "vue";
import { isNullOrWhitespace } from "../../../shared/utils/string";
import type { ProductListCachedProduct } from "../frontend-productlist/product-list/list-item";
import { registerProduct } from "../frontend-productlist/product-list/list-item-component/common/product-updater";
import labels from "../shared/labels";
import { enqueue } from "./fetch-list-queue";
import productGalleryItem from "./ProductGalleryItem.vue";
//import { resizeToMatchUp } from "./adjust-elements-to-align";
import fastdom from "fastdom";
import { getBrowserView } from "../../../utilities/browser-view";
import { getPagePosition } from "../../../utilities/dom-measurement";
import { type Segment } from "../frontend-productlist/product-list/segment";
import { getUniqueProductGalleryIdentifier } from "./product-gallery-counter";
import { createScrollController } from "./scrolling";
import { type GalleryItem } from "./types";

const margin = 5 * 2;

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductGallery',
  props: {
    centerHeader: Boolean,
    header1: {
        type: String,
        default: "",
    },
    header2: {
        type: String,
        default: "",
    },
    tag: {
        type: String,
        default: "div",
    },
    productsPerRow: {
        type: Number,
        default: 5,
    },
    products: {
        type: Array as PropType<Segment["products"]>,
        default: null,
    },
    fetchUrl: {
        type: String,
    },
    fetch: {
        type: Promise as PropType<Promise<Response>>,
    },
    prio: Number,
    expectedContentType: String,
    itemWidthStyle: String,
},
  setup(__props) {

const props = __props;

// const spacerWidth = ref(0);
const gallerySliderSize = ref(0);

const frame = ref<HTMLUListElement>();
const itemsEl = ref<InstanceType<typeof productGalleryItem>[]>();

const productsData = ref<Segment["products"]>([]);

const showFillers = computed(() => {
    return (
        props.products == null &&
        (props.fetchUrl != null || props.fetch != null) &&
        productsData.value.length === 0
    );
});

const identifier = ref(getUniqueProductGalleryIdentifier());

// because css wont do anything about this
// function timerResizeTitle() {
//     if (frame.value != null) {
//         resizeToMatchUp(identifier.value, frame.value, ".product-title");
//         resizeToMatchUp(identifier.value, frame.value, ".amounts");
//     }
//     requestAnimationFrame(() => {
//         setTimeout(() => timerResizeTitle(), 100);
//     });
// }

function createFiller(i: number, setFirst: boolean): GalleryItem {
    return {
        filler: true,
        key: "filler" + i,
        product: undefined,
        visible: false,
        loaded: false,
        first: setFirst && i === 0,
    };
}

function createFillers(n = 6, setFirst = true) {
    return Array.from(Array(n)).map((x, i) => createFiller(i, setFirst));
}

const items = ref<GalleryItem[]>(createFillers());

let uniqueCounter = 0;
function setItemsFromData() {
    // const pixWidth =
    //     pixelWidth.value != null ? pixelWidth.value + margin : undefined;
    // const frameWidth = frame.value?.offsetWidth;

    const result: GalleryItem[] = productsData.value.map((product, i) => {
        if (product == null || product == "filler")
            return createFiller(0, false);
        let visible = false;
        // if (pixWidth != null && frameWidth != null)
        //     visible = pixWidth * i < frameWidth;
        // else
        if (i < 5) {
            visible = true;
        }
        return {
            filler: false,
            key: "product" + product.productId + "_" + uniqueCounter++,
            product: product,
            visible: visible,
            loaded: visible,
        };
    });
    if (result.length > 0) {
        result[0].first = true;
    }

    for (const item of result) {
        if (item.filler) continue;
        if (!item.product) continue;
        if (item.product.registration) continue;
        item.product.registration = registerProduct(
            reactive({
                props: {
                    isShop: item.product.isShop,
                    productId: item.product.productId,
                    secondsLeft: item.product.timeTotalSeconds,
                },
            })
        );
    }

    items.value = result;
}

const itemWidth = computed(() => {
    if (props.itemWidthStyle != null) return props.itemWidthStyle;
    return "230px";
});

const pixelWidth = computed(() => {
    return itemWidth.value != null && itemWidth.value.endsWith("px")
        ? parseInt(itemWidth.value.substring(0, itemWidth.value.length - 2))
        : undefined;
});

// const spacerStyle = computed(() => {
//     const style: { [key: string]: string } = {};
//     style["width"] = spacerWidth.value + "px";
//     return style;
// });

const el = ref<HTMLElement>();

function stringIsNullOrWhitespace(s: string | null | undefined) {
    return isNullOrWhitespace(s);
}
function resizeEventHandler() {
    updateSizing();
}
function updateSizing() {
    setSizeForGallerySlider();
}
function setSizeForGallerySlider() {
    let width = gallerySliderSize.value;

    if (frame.value == null) return;

    const frameBoundRect = frame.value.getBoundingClientRect();

    width = frameBoundRect.width;

    gallerySliderSize.value = width;

    //console.log("NEW SIZE", width);
}
async function fetchFromUrl() {
    let responseData: {
        products: ProductListCachedProduct[];
        productsPerRow: number;
    };
    if (props.fetch != null) {
        responseData = (await (
            await props.fetch
        ).json()) as typeof responseData;
    } else if (props.fetchUrl != null) {
        try {
            const response = await axios.get<typeof responseData>(
                props.fetchUrl
            );
            responseData = response.data;
        } catch (e) {
            if (e instanceof CanceledError) {
                responseData = { products: [], productsPerRow: 5 };
                return;
            }
            throw e;
        }
    } else throw new Error("No fetchUrl");
    productsData.value = responseData.products;
    setItemsFromData();
}

onBeforeMount(() => {
    if (props.products != null) {
        productsData.value = props.products;
        setItemsFromData();
    } else if (
        (props.fetchUrl != null && props.fetchUrl != "") ||
        props.fetch != null
    ) {
        productsData.value = [];
        items.value = createFillers();
        enqueue(props.prio ?? 0, fetchFromUrl);
    }
});

const interscetionCallback: IntersectionObserverCallback = (entries) => {
    entries.forEach((x) => {
        if (x.target.getAttribute("data-item-type") !== "product") {
            return;
        }
        const key = x.target.getAttribute("data-item-key");
        const match = items.value.find((x) => x.key === key);
        if (match == null) {
            return;
        }
        match.intersection = x.intersectionRatio;
        match.visible = x.intersectionRatio > 0;
        if (match.visible) {
            match.loaded = true;
        }
    });
};

const scrollController = createScrollController(frame, items, el);

// setInterval(() => {
//     const itemsElValue = itemsEl.value;
//     if (itemsElValue == null) return;
//     for (const item of itemsElValue) {
//         item.$el.style.backgroundColor = "";
//     }
//     const result = getFirstAndLastFullyVisibleItem(itemsEl);
//     if (result.firstFullyVisible)
//         result.firstFullyVisible.el.style.backgroundColor = "green";
//     if (result.lastFullyVisible)
//         result.lastFullyVisible.el.style.backgroundColor = "red";
// }, 1000);

const intersectionObserver = ref<IntersectionObserver>();
const firstItemResizeObserver = ref<ResizeObserver>();

const firstItemWidth = ref<number>();

const observeQueue: HTMLElement[] = [];
const firstItemObserveQueue: HTMLElement[] = [];

const browserView = getBrowserView();
const forceLazyLoadImage = ref(true);

onMounted(async () => {
    //timerResizeTitle();

    if (el.value) {
        const rootEl = el.value;
        fastdom.measure(() => {
            const elOffset = getPagePosition(rootEl);

            const browserPos = browserView.value;
            if (
                elOffset.top < browserPos.bottom &&
                elOffset.bottom > browserPos.top
            ) {
                forceLazyLoadImage.value = false;
                //console.log("gallery in view");
            } else {
                //console.log("gallery outside view");
            }
        });
    }

    window.addEventListener("resize", () => {
        resizeEventHandler();
    });

    const options: IntersectionObserverInit = {
        root: frame.value,
        rootMargin: "0px",
        threshold: Array.from({ length: 100 }, (_, i) => i / 100),
    };

    intersectionObserver.value = new IntersectionObserver(
        interscetionCallback,
        options
    );
    for (const observeItem of observeQueue) {
        let el = observeItem;
        if ("$el" in el) {
            el = el.$el as HTMLElement;
        }
        intersectionObserver.value.observe(el);
    }

    firstItemResizeObserver.value = new ResizeObserver((entries) => {
        firstItemWidth.value = entries[0].contentRect.width;
    });

    for (const observeItem of firstItemObserveQueue) {
        let el = observeItem;
        if ("$el" in el) {
            el = el.$el as HTMLElement;
        }
        firstItemResizeObserver.value.observe(el);
    }
});

onBeforeUnmount(() => {
    intersectionObserver.value?.disconnect();
});

function itemMountEvent(item: GalleryItem, el: HTMLElement, index: number) {
    if (!item.filler) {
        observeItemEl(el);
    }
    if (index == 0) {
        observeFirstItemResize(el);
    }
}

function observeFirstItemResize(el: HTMLElement) {
    if (firstItemResizeObserver.value == null) {
        firstItemObserveQueue.push(el);
        return;
    }
    if ("$el" in el) {
        el = el.$el as HTMLElement;
    }
    firstItemResizeObserver.value.observe(el);
}

function observeItemEl(el: HTMLElement) {
    if (intersectionObserver.value == null) {
        observeQueue.push(el);
        return;
    }
    if (el === undefined) {
        console.warn("el is undefined. cannot observe.");
        return;
    }
    if ("$el" in el) {
        el = el.$el as HTMLElement;
    }
    if (!(el instanceof Element)) {
        //console.log(el);
        //debugger;
    }
    intersectionObserver.value.observe(el);
}
function itemUnmountEvent(item: GalleryItem, el: HTMLElement) {
    //if (item.filler) return;
    //console.log("UNOBSERVING");
    unobserveItemEl(el);
}
function unobserveItemEl(el: HTMLElement) {
    if (intersectionObserver.value == null) {
        const index = observeQueue.indexOf(el);
        if (index >= 0) {
            observeQueue.splice(index, 1);
        }
        return;
    }
    if ("$el" in el) {
        el = el.$el as HTMLElement;
    }
    intersectionObserver.value.unobserve(el);
}

function clickEvent(ev: Event) {
    //console.log("clickEvent");
}

// function getParentLink(el: EventTarget | Element | null) {
//     if (el == null) return undefined;
//     if (!(el instanceof Element)) return undefined;
//     if (el.tagName === "A") return el;
//     return getParentLink(el.parentElement);
// }
// let lastLog = "";
// const interval = setInterval(() => {
//     let logTxt =
//         "gallery items: " +
//         items.value?.length +
//         " frameheight" +
//         frame.value?.offsetHeight +
//         " firstFrameHeight" +
//         (frame.value?.children[0] as HTMLElement | undefined)?.offsetHeight +
//         " firstFrameSourceLen" +
//         (frame.value?.children[0] as HTMLElement | undefined)?.innerHTML.length;
//     if (
//         ((frame.value?.children[0] as HTMLElement | undefined)?.innerHTML
//             .length ?? 999999) < 2000
//     ) {
//         logTxt +=
//             " firstFrameSource: " +
//             (frame.value?.children[0] as HTMLElement | undefined)?.outerHTML;
//     }
//     if (logTxt == lastLog) return;
//     console.log(logTxt);
//     lastLog = logTxt;
// }, 10);
// onBeforeUnmount(() => {
//     clearInterval(interval);
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
    ref_key: "el",
    ref: el,
    class: "product-gallery",
    "aria-busy": showFillers.value ? 'true' : 'false',
    "aria-live": showFillers.value ? 'polite' : undefined,
    onDragstart: _cache[3] || (_cache[3] = ($event: any) => (_unref(scrollController).dragStart($event))),
    draggable: "true",
    onClick: clickEvent,
    "data-gallery-identifier": identifier.value
  }, {
    default: _withCtx(() => [
      (
                !stringIsNullOrWhitespace(__props.header1) ||
                !stringIsNullOrWhitespace(__props.header2) ||
                _ctx.$slots['top-part']
            )
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['top-part', __props.centerHeader ? 'centered' : ''])
          }, [
            _renderSlot(_ctx.$slots, "top-part", {}, () => [
              (
                        !stringIsNullOrWhitespace(__props.header1) ||
                        !stringIsNullOrWhitespace(__props.header2)
                    )
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (!stringIsNullOrWhitespace(__props.header1))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.header1), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (
                            !stringIsNullOrWhitespace(__props.header1) &&
                            !stringIsNullOrWhitespace(__props.header2)
                        )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" | ")
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (!stringIsNullOrWhitespace(__props.header2))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.header2), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "image-wrapper",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(scrollController).scrollLeft()))
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              width: "14",
              height: "24",
              alt: _unref(labels).frontendProductGallery.previous
            }, null, 8 /* PROPS */, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", {
          class: "product-gallery-slider",
          ref_key: "frame",
          ref: frame
        }, [
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.map((item, i) => ({
                            item,
                            i,
                        })), ({ item, i }) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.key
              }, [
                _createCommentVNode(" <template v-if=\"!item.first\">\r\n                            <li\r\n                                class=\"spacer\"\r\n                                :style=\"spacerStyle\"\r\n                                data-item-type=\"spacer\"\r\n                            ></li>\r\n                        </template> "),
                _createVNode(productGalleryItem, {
                  ref_for: true,
                  ref_key: "itemsEl",
                  ref: itemsEl,
                  filler: item.filler,
                  loaded: item.loaded,
                  "force-lazy-load-image": forceLazyLoadImage.value,
                  "data-item-type": "product",
                  "data-item-key": item.key,
                  width: itemWidth.value,
                  registration: item.product?.registration,
                  product: item.product,
                  "expected-content-type": __props.expectedContentType,
                  visible: item.visible,
                  "index-of-list": i,
                  onMounted: ($event: any) => (itemMountEvent(item, $event, i)),
                  onUnmount: ($event: any) => (itemUnmountEvent(item, $event)),
                  onDragstart: _cache[1] || (_cache[1] = ($event: any) => (_unref(scrollController).dragStart($event)))
                }, null, 8 /* PROPS */, ["filler", "loaded", "force-lazy-load-image", "data-item-key", "width", "registration", "product", "expected-content-type", "visible", "index-of-list", "onMounted", "onUnmount"])
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 512 /* NEED_PATCH */),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "image-wrapper",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(scrollController).scrollRight()))
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              width: "14",
              height: "24",
              alt: _unref(labels).frontendProductGallery.next
            }, null, 8 /* PROPS */, _hoisted_9)
          ])
        ])
      ])
    ], undefined, true),
    _: 3 /* FORWARDED */
  }, 40 /* PROPS, NEED_HYDRATION */, ["aria-busy", "aria-live", "data-gallery-identifier"]))
}
}

})